// import WalterLays from "./components/walter-lays";
// import WalterLaysNavigation from "./components/walter-lays-navigation";

import BarbaJs from "./features/barba-js";
new BarbaJs();

document.documentElement.classList.replace('no-js', 'js');
